import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message } from 'antd';
import { useAuth } from '../hooks/useAuth';
import api from '../services/api';

interface User {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  primary_role: string;
}

const UserManagement: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const { hasPermission } = useAuth();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await api.get('/users');
      setUsers(response.data);
    } catch (error) {
      message.error('Failed to fetch users');
    }
    setLoading(false);
  };

  const handleCreateUser = async (values: any) => {
    try {
      await api.post('/users', values);
      message.success('User created successfully');
      setModalVisible(false);
      form.resetFields();
      fetchUsers();
    } catch (error) {
      message.error('Failed to create user');
    }
  };

  const columns = [
    { title: 'First Name', dataIndex: 'first_name', key: 'first_name' },
    { title: 'Last Name', dataIndex: 'last_name', key: 'last_name' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Primary Role', dataIndex: 'primary_role', key: 'primary_role' },
  ];

  return (
    <div>
      <h1>User Management</h1>
      {hasPermission(['create_user']) && (
        <Button type="primary" onClick={() => setModalVisible(true)} style={{ marginBottom: 16 }}>
          Create User
        </Button>
      )}
      <Table columns={columns} dataSource={users} loading={loading} rowKey="id" />

      <Modal
        title="Create User"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <Form form={form} onFinish={handleCreateUser}>
          <Form.Item name="first_name" rules={[{ required: true }]}>
            <Input placeholder="First Name" />
          </Form.Item>
          <Form.Item name="last_name" rules={[{ required: true }]}>
            <Input placeholder="Last Name" />
          </Form.Item>
          <Form.Item name="email" rules={[{ required: true, type: 'email' }]}>
            <Input placeholder="Email" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true }]}>
            <Input.Password placeholder="Password" />
          </Form.Item>
          <Form.Item name="primary_role" rules={[{ required: true }]}>
            <Input placeholder="Primary Role" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Create
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default UserManagement;